<template>
    <!--
          作者：bbc_team
          时间：2023-06-08
          描述：登录页面
      -->
    <div class="login-bg" :style="'background-image:url(' + bgimg_url + ');'">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="0px" class="demo-ruleForm login-container">
            <h3 class="title" style="margin-bottom: 20px;">{{ merch_name }}</h3>
            <!--用户名-->
            <el-form-item prop="account"><el-input v-model="ruleForm.account" type="text" auto-complete="off" placeholder="账号"></el-input></el-form-item>
            <!--密码-->
            <el-form-item prop="checkPass"><el-input v-model="ruleForm.checkPass" type="password" auto-complete="off" placeholder="密码"></el-input></el-form-item>
            <!--登录-->
            <el-form-item><el-button type="primary" style="width:100%;" :loading="logining" @click.native.prevent="SubmitFunc">登录</el-button></el-form-item>
        </el-form>

        <!-- 验证码滑块弹窗和容器 -->
        <div class="verify-box">
            <div id="captcha-box">
                <div id="captcha"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/js/jquery-2.1.4.min.js";
    import IndexApi from "@/api/index.js";
    import bgimg from "@/assets/img/login_bg.png";
    import UserApi from "@/api/user.js";
    import { setCookie, setSessionStorage } from "@/utils/base.js";

    var $captcha = null;
    export default {
        data() {
            return {
                /*是否正在加载*/
                loading: true,
                /*系统名称*/
                merch_name: "",
                /*背景图片*/
                bgimg_url: "",
                /*是否正在提交*/
                logining: false,
                /*表单对象*/
                ruleForm: {
                    /*用户名*/
                    account: "",
                    /*密码*/
                    checkPass: ""
                },
                /*验证规则*/
                rules: {
                    /*用户名*/
                    account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
                    /*密码*/
                    checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }]
                },
                /*基础配置*/
                baseData: {}
            };
        },
        created() {
            this.loadScript("./static/plug/sliderCaptcha/longbow.slidercaptcha.js");
            this.getData();
        },
        methods: {
            loadScript(url) {
                let script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                document.body.appendChild(script);
            },
            /*获取基础配置*/
            getData() {
                let self = this;
                IndexApi.base(true)
                    .then((res) => {
                        self.loading = false;
                        self.baseData = res.data;
                        self.merch_name = res.data.settings.merch_name;
                        if (res.data.settings.merch_bg_img != "") {
                            self.bgimg_url = res.data.settings.merch_bg_img;
                        } else {
                            self.bgimg_url = bgimg;
                        }
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*登录方法*/
            SubmitFunc(ev) {
                var _this = this;
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if ($captcha) {
                            $(".verify-box").show();
                            $captcha.sliderCaptcha("reset");
                        } else {
                            $(".verify-box").show();
                            $captcha = $("#captcha").sliderCaptcha({
                                onSuccess: function(e) {
                                    _this.logining = true;
                                    let Params = {};
                                    Params.username = _this.ruleForm.account;
                                    Params.password = _this.ruleForm.checkPass;
                                    //验证码通过后做出处理
                                    Params.token = e.token;
                                    Params.local_x = e.local_x;
                                    /*调用登录接口*/
                                    UserApi.login(Params, true)
                                        .then((res) => {
                                            _this.logining = false;
                                            if (res.code == 1) {
                                                /*保存个人信息*/
                                                setCookie("userinfo_merch", JSON.stringify(res.data));
                                                /*设置一个登录状态*/
                                                setCookie("isLogin_multimerch", true);
                                                /*跳转到首页*/
                                                _this.$router.push({ path: "/" });
                                            } else {
                                                _this.$message({
                                                    message: "登录失败",
                                                    type: "error"
                                                });
                                            }
                                        })
                                        .catch((error) => {
                                            //接口调用方法统一处理
                                            _this.logining = false;
                                        });
                                    $(".verify-box").hide();
                                },
                                onFail: function() {
                                    _this.$message({
                                        showClose: true,
                                        message: "验证错误，请重试!",
                                        type: "error",
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    }
                });
            }
        }
    };
</script>

<!-- 滑动验证码 -->
<style>
    @import "../../static/plug/sliderCaptcha/font-awesome/css/font-awesome.min.css";
    @import "../../static/plug/sliderCaptcha/slidercaptcha.css";
</style>
<style lang="scss" scoped>
    .login-bg {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
    }

    .login-container {
        // box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.1), 0 1px 0px 0 rgba(0, 0, 0, 0.04);
        box-shadow: 0px 0px 2px 2px #66666640;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        position: fixed;
        width: 350px;
        left: 50%;
        top: 50%;
        margin-left: -175px;
        margin-top: -175px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/login.vue